import { Context } from "csi/def/Context";
import Widget from "csi/gallery/Widget";
import { QueryLevel } from "csi/view/_query/Level";
import declare from "dojo/_base/declare";
import {
	getDependencyPathForPresentationFromRuntimeRule,
	getPresentationRuntimeRules,
	setHasViolationUnderPresentation
} from "./PPService";

const PresentationSetGallery = declare(Widget, {
	/** @property {string[]} - dependency paths to evaluate the violations */
	dependencyPaths: null,

	/** @property {RuntimeRulesSchema} - runtime rules */
	runtimeRules: null,

	/**
	 * @override
	 * include the dependency on the relationship level so that being able to evaluate the violations
	 */
	onCreateMainQueryLevel(ql: QueryLevel) {
		ql.addDependencyPaths(this.dependencyPaths);
	},

	/**
	 * @override
	 * get the rule information in advance
	 */
	onViewStart(dfds) {
		const presentationUrl = this.getViewNode().$URL;
		const cache = this.getContext().cache;

		dfds.push(getPresentationRuntimeRules(presentationUrl, cache).then((runtimeRules) => {
			this.runtimeRules = runtimeRules;
			this.dependencyPaths = getDependencyPathForPresentationFromRuntimeRule(runtimeRules);;
		}));
	},

	/**
	 * @override
	 * reset the violation urls so that it would re-evaluate the violations
	 */
	_postView() {
		this.dependencyPaths = null;

		this.inherited(arguments);
	},

	/**
	 * @override
	 * show the violation of set properly
	 */
	_processHtml(ctx: Context, domNode: HTMLElement) {
		const { runtimeRules } = this;
		const setNode = ctx.getNode();
		const presentation = ctx.getParent();
		const cache = ctx.cache;

		if (setHasViolationUnderPresentation(presentation, setNode, runtimeRules, cache)) {
			domNode.classList.add("presentation-set-invalid");
		}

		this.inherited(arguments);
	},
});

export = PresentationSetGallery;